import CloseButton from "../../../../../components/CloseButton";
import ReviewSettingsPanel from "../../../../../components/ReviewSettingsPanel";
import AnalysisSelectionPage from "./analysis/AnalysisSelectionPage";
import ComprehensiveSelectionPage from "./comprehensive/ComprehensiveSelectionPage";
import VocabularySelectionPage from "./vocabulary/VocabularySelectionPage";
import SentenceSelectionPage from "./sentence/SentenceSelectionPage";
import GrammarSelectionPage from "./grammar/GrammarSelectionPage";
import { allTypes } from "../../WorksheetModal/constants";

/**
 * ── 변경사항 (ECHO 톤) ──
 * 1. 고정 500px → max-width 520px + 반응형 (모바일 전체 화면)
 * 2. 콘텐츠 스크롤 영역과 하단 고정 바 분리
 * 3. onClickPrev 추가 → 이전/다음 버튼
 */
const TypeSelectionPage = ({
  worksheet,
  onClose,
  onClickPrev,
  onClickNext,
  selectedTypes,
  setSelectedTypes,
  isRetryEnabled,
  setIsRetryEnabled,
  isAutoRetryEnabled,
  setIsAutoRetryEnabled,
  maxRetries,
  setMaxRetries,
}) => {
  return (
    <div
      
      style={{ position: "relative", width: "100%", display: "flex", flexDirection: "column", minHeight: 0, maxHeight: "calc(80vh - 62px)", overflow: "hidden" }}
    >
      <CloseButton onClick={onClose} />

      <div className="ws-scroll" style={{ flex: 1, minHeight: 0, overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
        {worksheet.type === "analysis" && (
          <AnalysisSelectionPage
            allTypes={allTypes}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        )}
        {worksheet.type === "comprehensive" && (
          <ComprehensiveSelectionPage
            worksheet={worksheet}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        )}
        {worksheet.type === "vocabulary" && (
          <VocabularySelectionPage
            worksheet={worksheet}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        )}
        {worksheet.type === "sentence" && (
          <SentenceSelectionPage
            worksheet={worksheet}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        )}
        {worksheet.type === "grammar" && (
          <GrammarSelectionPage
            worksheet={worksheet}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
          />
        )}

        {/* 복습 설정은 **유형을 고르는 이 화면**에 둔다. 무엇을 낼지 정하는 자리가
            복습을 켜는 자리로도 자연스럽고, 지문 화면에 두면 지문이 길 때 스크롤
            맨 아래로 밀려 아무도 못 찾는다(실제로 못 찾았다).
            유형 화면이 없는 모의고사만 `ParagraphSelectionPage` 에 둔다. */}
        {setMaxRetries && (
          <div style={{ margin: "6px 0 16px", maxWidth: "560px" }}>
            <ReviewSettingsPanel
              isRetryEnabled={isRetryEnabled}
              onToggleRetry={() => setIsRetryEnabled(!isRetryEnabled)}
              isAutoRetryEnabled={isAutoRetryEnabled}
              onSetAutoRetry={setIsAutoRetryEnabled}
              maxRetries={maxRetries}
              onSetMaxRetries={setMaxRetries}
            />
          </div>
        )}
      </div>

      {onClickNext && (
        <div className="ws-bottom-bar">
          {onClickPrev && (
            <button className="ws-btn-prev" onClick={onClickPrev}>
              이전
            </button>
          )}
          <button className="ws-btn-next" onClick={onClickNext}>
            다음
          </button>
        </div>
      )}
    </div>
  );
};

export default TypeSelectionPage;
